// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_fo_booking_ticket_ts-node_modules_file-saver_FileSaver_js-node_modules_angula-f8eef5":"acb9d0d37e73cf32","src_app_bo_bo_module_ts":"1a6596b6c584ca43","src_app_fo_fo_module_ts":"a5742faa8682f5d8"}[chunkId] + ".js";
};